export const FANTOM_MEASUREMENT_CLASS = "fantom-measurement-item";

export const measurementsLimit = 10;
